// ============================================================================
// CANCUN100 — reglasAdmin.js  (Bloque 22: "+ Reserva (admin)" con regla contable elegible)
// ----------------------------------------------------------------------------
// Ventas hechas por un administrador (Tere, Alan, Marco): canal 'admin', agente_id NULL,
// vendido_por_admin_id = quien la hizo, folio ADM-. La regla se elige en el formulario, se graba en
// reservas.regla_comision y la base la congela (trigger). Para agregar reglas: solo esta lista.
//
// Cálculo (NO toca Sala ni Top Tours):
//   margen = total − neto (SIN quitar el 5 %, igual que TT); el cargo de pasarela es informativo.
//   Sin $40 de supervisor. comision_vendedor → reservas.comision_agente; casa → ganancia_agencia.
// ============================================================================
export const REGLAS_ADMIN = [
  { clave: 'admin_casa_100', etiqueta: '100 % casa', descripcion: 'Sin comisión a nadie: todo el margen es ganancia de la agencia.', pct_vendedor: 0 },
  { clave: 'admin_vendedor_100', etiqueta: '100 % para quien vendió', descripcion: 'Todo el margen (sin el 5 %) se registra como comisión del admin que vendió; casa 0.', pct_vendedor: 1 },
  { clave: 'admin_80_20', etiqueta: '80 / 20', descripcion: '80 % del margen para quien vendió, 20 % casa.', pct_vendedor: 0.8 },
  // Bloque 26: reparto libre y simétrico. El % del vendedor (0–100) viaja en reservas.pct_agente_tt y la base lo congela.
  { clave: 'admin_libre', etiqueta: 'Reparto libre', descripcion: 'Casa y vendedor según los porcentajes elegidos en el formulario.', pct_vendedor: null },
];
// % del vendedor (0–100) de un folio: libre → pct_agente_tt; reglas fijas → su porcentaje.
export const pctVendedorDe = (clave, pctGuardado) => {
  const r = reglaAdminDe(clave);
  if (!r) return null;
  if (r.pct_vendedor != null) return Math.round(r.pct_vendedor * 100);
  if (pctGuardado == null || pctGuardado === '') return null; // libre sin porcentaje = inválido
  const n = Number(pctGuardado);
  return Number.isFinite(n) ? Math.max(0, Math.min(100, Math.round(n))) : null;
};

export const reglaAdminDe = (clave) => REGLAS_ADMIN.find((r) => r.clave === clave) || null;
export const esReglaAdmin = (clave) => !!reglaAdminDe(clave);
export const etiquetaReglaAdmin = (clave, pctGuardado) => {
  const r = reglaAdminDe(clave);
  if (!r) return String(clave || '');
  const pv = pctVendedorDe(clave, pctGuardado);
  if (pv == null) return r.etiqueta;
  return r.clave === 'admin_libre' ? `Casa ${100 - pv} % / Vendedor ${pv} %` : `${r.etiqueta} (${pv} % vendedor · ${100 - pv} % casa)`;
};

const r2 = (n) => Math.round((Number(n) || 0) * 100) / 100;

// { tFinal, sumNet, regla, esEfectivo } → montos de la venta admin.
// pctVendedor (0–100) solo aplica a 'admin_libre'.
export function calcComisionAdmin({ tFinal, sumNet, regla, esEfectivo = false, pctVendedor = null }) {
  const r = reglaAdminDe(regla);
  const total = Number(tFinal) || 0;
  const neto = Number(sumNet) || 0;
  const margen = r2(total - neto);
  const base = Math.max(0, margen);
  const pv = pctVendedorDe(regla, pctVendedor);
  const pct = pv == null ? 0 : pv / 100;
  const comisionVendedor = r2(base * pct);
  return {
    regla_comision: r ? r.clave : null,
    pct_vendedor: pct,
    pct_agente_tt: pv, // 0–100; en 'admin_libre' es lo que se guarda en reservas.pct_agente_tt
    comision_supervisor: 0,
    margen,
    comision_vendedor: comisionVendedor,
    ganancia_agencia: r2(margen - comisionVendedor),
    cargo_pasarela: esEfectivo ? 0 : r2(total - total / 1.05), // informativo: no se resta del margen
    bajo_neto: total < neto,
  };
}
